import { render, staticRenderFns } from "./StatisticsDoctype.vue?vue&type=template&id=2a87640f&"
import script from "./StatisticsDoctype.vue?vue&type=script&lang=js&"
export * from "./StatisticsDoctype.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports